import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/docs/terms/TermsView.tsx");
